import { getFile } from 'utils/fileCache';
import { isNil } from 'ramda';
import { enableSound } from 'utils/audio/audio';

type AudioPlayerSettings = {
  src: string;
  start: number;
  duration: number;
  isPlaying: boolean;
};

export class AudioPlayer {
  protected element: HTMLAudioElement;

  private time: number;

  settings: AudioPlayerSettings;

  constructor(settings: AudioPlayerSettings) {
    this.element = new Audio();
    this.updateSettings(settings);
    this.settings.isPlaying && this.play();
  }

  updateSettings(settings: AudioPlayerSettings) {
    this.settings = settings;
    this.element.src = settings.src;
    this.element.currentTime = Math.fround(settings.start / 1000);
    this.time = null;
  }

  play() {
    this.element.paused && this.element.play();
  }

  pause() {
    this.element.paused || this.element.pause();
  }

  enableSound() {
    enableSound(this.element);
  }

  setTime(time: number) {
    const { start, duration } = this.settings;
    const currentTime = this.element.currentTime * 1000;

    this.time = time;

    if (duration === 0) return;

    if (currentTime / (start + duration) > 1) {
      this.element.currentTime = Math.fround(start / 1000);
    }

    if (!isNil(this.time) && Math.abs(this.time - time) > 1000) {
      this.element.currentTime = Math.fround((start + (time % duration)) / 1000);
    }

    if (Math.abs((time % duration) + start - currentTime) > 1000) {
      this.element.currentTime = Math.fround((start + (time % duration)) / 1000);
    }
  }
}

export const createAudioPLayer = async (
  url: string,
  duration: number,
  start: number,
  isPlaying: boolean
) => {
  const src = await getFile(url);

  const settings = {
    src,
    start,
    duration,
    isPlaying
  };

  const audioPlayer = new AudioPlayer(settings);
  return audioPlayer;
};
